import countryList from 'country-list';
import useLocale from './use-locale';
import usePageType from './use-page-type';
import useBookingMinimalShop from '../Pages/Booking/server-data/use-booking-minimal-shop';
import useGiftcardMinimalShop from '../Pages/Giftcard/server-data/use-giftcard-minimal-shop';
import useBookingEditShop from '../Pages/BookingEdit/server-data/use-booking-edit-shop';
import useMembershipShop from '../Pages/Membership/server-data/use-membership-shop';

countryList.overwrite([
  {
    code: 'US',
    name: 'United States',
  },
]);

const useFormatPrice = () => {
  const { locale } = useLocale();
  const pageType = usePageType();

  // Get currency from minimalShop on booking- and giftcard page
  // Get currency from shop on other pages
  let currency: string | undefined;

  const { data: bookingMinimalShop } = useBookingMinimalShop(false);
  const { data: giftcardMinimalShop } = useGiftcardMinimalShop(false);
  const { data: bookingEditShop } = useBookingEditShop(false);
  const { data: membershipShop } = useMembershipShop(false);

  switch (pageType) {
    case 'booking':
      currency = bookingMinimalShop?.currency;
      break;
    case 'giftcard':
      currency = giftcardMinimalShop?.currency;
      break;
    case 'edit-booking':
      currency = bookingEditShop?.currency;
      break;
    case 'membership':
      currency = membershipShop?.currency;
      break;
  }

  const formatPrice = (price: number) => {
    if (currency) {
      const options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      };
      return (price / 100).toLocaleString(locale, options);
    }

    if (price && !currency) {
      return (price / 100).toLocaleString(locale);
    }

    return String(price);
  };

  return formatPrice;
};

export default useFormatPrice;
